export const SITE_NAME = 'The Racket Center'

/**
 * THE TAB LABEL, and the name a shared link says it comes from.
 *
 * Every page is `"<page> — The Racket Center"`, which is the right answer everywhere on
 * our own site. A Club Storefront is the exception the owner is selling: the club's page
 * is the CLUB's, and a tab reading "— The Racket Center" hands its visitor the name of
 * the platform the club is paying to keep off it. Such a page passes its own `siteName`
 * and gets it in both the title and `og:site_name`.
 *
 * THE DEFAULT PATH IS UNTOUCHED. With no `siteName` the result is character-for-
 * character what it always was — the de-duplication below applies only where a caller
 * names its own site, so no existing page's title can shift under it.
 *
 * The de-duplication matters because a club page's title already opens with the club's
 * name ("Padel Alpha in Santo Domingo — Courts, Hours & Booking"). Appending the same
 * name again would read as a stutter, so a title that already carries the site name is
 * left exactly as it is.
 */
export function buildPageTitle(title: string, siteName?: string): string {
  const page = String(title ?? '').trim()
  const site = String(siteName ?? '').trim()
  if (!site) return `${page} — ${SITE_NAME}`
  if (!page) return site
  return page.toLowerCase().startsWith(site.toLowerCase()) ? page : `${page} — ${site}`
}
